import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";
import isMobilePhone from "validator/lib/isMobilePhone";

// Landlines and formatted input are valid. Without a "+" prefix or a
// defaultCountry, only national-format mobiles can be recognized.
export const isValidPhoneNumber = (
  phoneNumber: string,
  defaultCountry?: CountryCode,
): boolean => {
  const trimmed = phoneNumber.trim();
  if (parsePhoneNumberFromString(trimmed, defaultCountry)?.isValid()) {
    return true;
  }
  return isMobilePhone(trimmed);
};
